export default class CardUtils
{

    static pathToId(cardPath)
    {
        var parsed = cardPath.split(".");
        var result = parsed[parsed.length-1];
        return result;
    }

    static titleToId(title)
    {
        var result = title.replaceAll(" ", "");
        result = result.replaceAll("/","");
        return result.toLowerCase();
    }

    static toTitle(title)
    {
        // keeps case
        return title.replace(/ /g, "").replaceAll(/\//g, "").replaceAll(/\\/g, "");
    }

    static  findCard(schema, cardId)
    {
        var lCardId = cardId.toLowerCase();
        var result = null;
        for (var i=0; i<schema.categories.length; i++)
        {
            var category = schema.categories[i];
            for (var j=0; j<category.groups.length; j++)
            {
                var group = category.groups[j];
                if (group.cards.some((card) => card.id.toLowerCase() === lCardId))
                {
                    var result = group.cards.find((card) => card.id.toLowerCase() === lCardId);
                    return result;
                }
            }
        }
    }


    static  findAllCardsInCategory(schema, category)
    {
        var result = [];
        //var category = schema.categories.find((cat) => cat.id === categoryId);
        for (var j=0; j<category.groups.length; j++)
        {
            var group = category.groups[j];
            for (var k=0; k<group.cards.length; k++)
            {
                var card = group.cards[k];
                result.push(card);
            }
        }
        return result;
    }

}